import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import membership from './modules/auth/Membership';
import userProfile from './modules/auth/UserProfile';
import vendor from './modules/auth/Vendor';

/* BaseInfo */
import brand from './modules/baseInfo/Brand';
import product from './modules/baseInfo/Product';
import productCategory from './modules/baseInfo/ProductCategory';
import productColor from './modules/baseInfo/ProductColor';
import productComment from './modules/baseInfo/ProductComment';
import productFinding from './modules/baseInfo/ProductFinding';
import productFindingReply from './modules/baseInfo/ProductFindingReply';
import productImage from './modules/baseInfo/ProductImage';
import imageManager from './modules/baseInfo/ImageManager';
import appointmentOption from './modules/baseInfo/AppointmentOption';
import productAppointmentOption from './modules/baseInfo/ProductAppointmentOption';
import userProductAppointment from './modules/baseInfo/UserProductAppointment';

/* Weixin */
import wxApp from './modules/weixin/WxApp';
import wxUser from './modules/weixin/WxUser';
import wxUserApp from './modules/weixin/WxUserApp';
import share from './modules/weixin/Share';
import wxAppUser from './modules/weixin/WxAppUser';
import weixin from './modules/weixin/Weixin'

/* Portal */
import subject from './modules/baseInfo/Subject';
import subjectCategory from './modules/baseInfo/SubjectCategory';
import subjectComment from './modules/baseInfo/SubjectComment';

/* Marketing */
import activity from './modules/marketing/Activity';
import activityType from './modules/marketing/ActivityType';
import advertisement from './modules/marketing/Advertisement';
import coupon from './modules/marketing/Coupon';
import couponType from './modules/marketing/CouponType';
import userActivity from './modules/marketing/UserActivity';
import userCoupon from './modules/marketing/UserCoupon';
import userPointDetail from './modules/marketing/UserPointDetail';
import pointRule from './modules/marketing/PointRule';
import pointType from './modules/marketing/PointType';

/* ShoppingCart */
import favoriteItem from './modules/shoppingCart/FavoriteItem';
import shoppingCartItem from './modules/shoppingCart/ShoppingCartItem';

/* Ordering */
import address from './modules/ordering/Address';
import order from './modules/ordering/Order';
import orderItem from './modules/ordering/OrderItem';
import rechargeCardOrder from './modules/ordering/RechargeCardOrder';
import vipCardOrder from './modules/ordering/VipCardOrder';

/* Finance */
import rechargeCard from './modules/finance/RechargeCard';
import vipCard from './modules/finance/VipCard';
import wallet from './modules/finance/Wallet';
import withdrawal from './modules/finance/Withdrawal';
import payment from './modules/Payment';

const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        membership,
        userProfile,
        vendor,

        /* BaseInfo */
        brand,
        product,
        productCategory,
        productColor,
        productComment,
        productImage,
        productFinding,
        productFindingReply,
        imageManager,
        appointmentOption,
        productAppointmentOption,
        userProductAppointment,

        /* Weixin */
        wxApp,
        wxUser,
        wxUserApp,
        share,
        wxAppUser,
        weixin,

        /* Portal */
        subject,
        subjectCategory,
        subjectComment,

        /* Marketing */
        activity,
        activityType,
        advertisement,
        coupon,
        couponType,
        userActivity,
        userCoupon,
        userPointDetail,
        pointRule,
        pointType,

        /* ShoppingCart */
        favoriteItem,
        shoppingCartItem,

        /* Ordering */
        address,
        order,
        orderItem,
        rechargeCardOrder,
        vipCardOrder,

        /* Finance */
        rechargeCard,
        vipCard,
        wallet,
        withdrawal,
        payment,
    }
});

export default store;